import { notifications } from "@mantine/notifications"
import { nprogress } from "@mantine/nprogress"
import { AxiosError } from "axios"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"
import { useExportCertificatesPdf } from "~/gen/api"
import { downloadFile } from "~/utils/downloadFile"

export const useExportCertificatesPdfMutation = () =>
  useExportCertificatesPdf({
    mutation: {
      mutationFn: async (variables) => {
        return httpClient.post(
          `/v1/certificate/export-certificates-pdf`,
          variables,
          {
            responseType: "blob",
            onDownloadProgress: (progressEvent) => {
              if (progressEvent.total) {
                const percentCompleted = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                )
                nprogress.set(percentCompleted)
              }
            },
          }
        )
      },
      onSuccess: async (data) => {
        const arrayBuffer = await data.data.arrayBuffer()
        const uint8Array = new Uint8Array(arrayBuffer)
        downloadFile(uint8Array, "certificates.zip", "application/zip")
        await queryClient.invalidateQueries(["certificates"])
        nprogress.reset()
      },
      onError: async (error) => {
        if (error instanceof AxiosError) {
          nprogress.reset()
          let errorMessage = error.message
          if (error.response?.data instanceof Blob) {
            try {
              errorMessage = await error.response.data.text()
            } catch (e) {
              console.error("Error parsing error response:", e)
            }
          }
          notifications.show({
            title: "Error exporting certificates",
            message: errorMessage,
            color: "red",
          })
        }
      },
    },
  })
